module.exports = __webpack_public_path__ + "static/media/LogoSingtel.bd0ce865.svg";